import { getFixedWhereClause } from '@modules/common/utils';
import {
  denormaliseQuery,
  getErrorNode,
  hasIncompleteFilters,
} from '@modules/queryBuilder/helpers';
import { QueryBuilderActionType } from '@modules/queryBuilder/store/queryBuilderActionType';
import { useQueryBuilderStore } from '@modules/queryBuilder/store/useQueryBuilderStore';
import { QueryOnChangeProps } from '@modules/queryBuilder/types';
import { useUpdateEffect } from 'react-use';
import toWhereClause from 'v2/core/services/queryBuilder/toWhereClause';

export function useQueryChangeNotifier(
  onChange: (params: QueryOnChangeProps) => void,
) {
  const nodes = useQueryBuilderStore(({ query }) => query.nodes);
  const rootID = useQueryBuilderStore(({ query }) => query.rootID);
  const dispatch = useQueryBuilderStore(({ dispatch }) => dispatch);

  useUpdateEffect(() => {
    const whereClause = toWhereClause(denormaliseQuery(nodes, rootID));
    const hasIncompleteRule = hasIncompleteFilters(nodes);
    const error = getErrorNode(nodes, rootID);

    // TODO, remove this once BE deprecates <code>FILE_UPLOAD</code>
    // It is required to make EQL/mapper understands the data format.
    const fixedWhereClause = getFixedWhereClause(whereClause);

    const payload = hasIncompleteRule
      ? { hasIncompleteFilters: hasIncompleteRule, error }
      : {
          hasIncompleteFilters: hasIncompleteRule,
          whereClause: fixedWhereClause,
          error,
        };

    dispatch({
      type: QueryBuilderActionType.SET_METADATA,
      payload,
    });

    if (!hasIncompleteRule) {
      onChange({
        whereClause: fixedWhereClause,
      });
    }
  }, [nodes, rootID]);
}
